<template>
  <ais-instant-search
    :search-client="searchClient"
    :index-name="courseIndex"
    class=" featured-courses-slider"
  >
    <ais-hits>
      <swiper
        slot-scope="{ items }"
        class="swiper-container"
        :options="swiperOptions"
      >
        <swiper-slide
          v-for="course in items"
          :key="course.id"
          class="swiper-slide featured-courses-slider__slide"
          :style="
            `background-image: url(${$getCourseBackground(
              course,
              'large'
            )}), linear-gradient(${$getGradient()});`
          "
        >
          <div class="featured-courses-slider__overlay"></div>
          <div class="featured-courses-slider__course-wrapper">
            <div class="featured-courses-slider__vendor">
              {{ course.vendor }}
            </div>
            <div class="featured-courses-slider__title">{{ course.title }}</div>
            <div class="featured-courses-slider__description">
              {{ course.description | shorten }}
            </div>
            <div class="featured-courses-slider__buttons">
              <router-link
                class="featured-courses-slider__play-btn btn btn__large"
                :to="{
                  name: 'course',
                  params: { slug: course.slug, id: course.id },
                }"
              >
                View Course
                <i class="material-icons btn__large-icon">play_circle_filled</i>
              </router-link>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-button-next" slot="button-prev">
          <i class="material-icons featured-courses-slider__right-slide"
            >keyboard_arrow_right</i
          >
        </div>
        <div class="swiper-button-prev" slot="button-next">
          <i class="material-icons featured-courses-slider__left-slide"
            >keyboard_arrow_left</i
          >
        </div>
      </swiper>
    </ais-hits>
    <ais-configure :query="''" :filters="`featured:1`" />
  </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'FeaturedCoursesSlider',
  data() {
    return {
      searchClient: algoliasearch(
        process.env.VUE_APP_ALGOLIA_APP_ID,
        process.env.VUE_APP_ALGOLIA_APP_KEY
      ),
      courseIndex: process.env.VUE_APP_ALGOLIA_COURSES_INDEX,
      swiperOptions: {
        loop: true,
        effect: 'slide',
        speed: 2500,
        autoplay: {
          delay: 7000,
        },
        freemode: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  components: {
    swiper,
    swiperSlide,
  },
  filters: {
    shorten(value) {
      if (value.length > 220) {
        return `${value.substr(0, 220)} [...]`
      }
      return value
    },
  },
}
</script>

<style lang="scss" scoped>
.featured-courses-slider {
  &__slide {
    color: var(--white);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: left;
    z-index: 1;
    position: relative;
    height: 100%;
    padding: 30px 0 0 0;
    @include mobile {
      min-height: 575px;
      background-position: inherit;
    }
  }
  &__overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.6),
      var(--dark-gray)
    );
    right: 0;
    top: 0;
    z-index: -1;
  }
  &__course-wrapper {
    display: flex;
    flex-direction: column;
    padding: 120px 30px 0 30px;
    width: 100%;
    @include desktop {
      padding: 0 150px;
      margin: 100px 0 0 0;
    }
  }
  &__vendor {
    font-size: 14px;
    font-family: var(--font-medium);
    text-transform: uppercase;
    width: 100%;
    margin: 0 0 15px 0;
  }
  &__title {
    font-size: 52px;
    font-family: var(--font-bold);
    letter-spacing: -1.04px;
    line-height: 3.5rem;
    width: 90%;
    margin: 0 0 45px 0;
    @include desktop {
      width: 50%;
    }
  }
  &__description {
    font-family: var(--font-medium);
    letter-spacing: -0.36px;
    font-size: 18px;
    width: 80%;
    margin: 0 0 50px 0;
    @include desktop {
      width: 45%;
      margin: 0 0 25px 0;
    }
  }
  &__buttons {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    align-items: center;
  }
  &__play-btn {
    min-width: 130px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    background: none;
  }
  .swiper-button-next {
    margin-right: 20px;
  }
  &__left-slide,
  &__right-slide {
    transition: 0.5s all ease;
    color: var(--white);
    font-size: 2rem;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 10px;
    border-radius: 100%;
    opacity: 0.5;
    @include mobile {
      font-size: 1rem;
    }
    &:hover {
      color: var(--white);
      background-color: rgba(0, 0, 0, 1);
      opacity: 1;
      transform: scale(1.2);
    }
  }
}
</style>
